import { render, staticRenderFns } from "./BoxQuiz.vue?vue&type=template&id=40f25d0e&"
import script from "./BoxQuiz.vue?vue&type=script&lang=js&"
export * from "./BoxQuiz.vue?vue&type=script&lang=js&"
import style0 from "./BoxQuiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports